<template>
  <div class="overview-content">
    <div :id="`video-player-${overview.title}`" ref="video-container"></div>
    <div class="content">
      <h4 class="title">{{ overview.title }}</h4>
      <p class="description">{{ overview.description }}</p>
    </div>
  </div>
</template>

<script>
import { loadJWP, fetchVideoFromJWplayer } from "@/api/jwplayer"
export default {
  props: ["overview"],
  methods: {
    async setupVideo () {
      const data = await fetchVideoFromJWplayer(this.overview.id)
      let volume = window.localStorage.getItem("jwplayer.volume")
      if (volume === null || volume === undefined) {
        volume = 50
      } else {
        volume = Math.round(volume)
      }
      try {
        // eslint-disable-next-line no-undef
        const player = jwplayer(`video-player-${this.overview.title}`).setup({
          file: data.playlist[0].sources[0].file,
          mute: false,
          width: "100%",
          autostart: false,
          volume,
          image: data.playlist[0].image,
        })
        player.on("play", () => {
          if (player.getMute()) {
            player.setMute(false)
          }
        })
      } catch (error) {
        console.log("jwplayer is not ready, trying it again")
        if (this.$refs["video-container"]) {
          setTimeout(this.setupVideo, 100)
        }
      }
    },
  },
  async mounted () {
    await loadJWP()
    this.setupVideo()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-align: left;
  gap: 2.8rem;
  margin-top: 2.8rem;
  padding: 0 6rem;
  @include phone-down {
    grid-template-columns: 1fr;
    padding: 0;
    gap: 0.8rem;
  }
  &:nth-of-type(2n) {
    direction: rtl;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title {
      font-weight: 500;
      font-size: 2rem;
      line-height: 3rem;
    }
    .description {
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 2.1rem;
    }
  }
  >>> .jwplayer {
    border-radius: 1rem;

    .jw-svg-icon-play path {
      display: none;
    }
    .jw-svg-icon-play {
      background-image: url("../../../../assets/images/icons/play/play_circle-red.svg");
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/overview/OverviewContent.vue